import constants from 'scoreboard/components/constants'
import _ from 'lodash'

/**
 * Returns the ideal width for a tiled bootslide menu based on the window size
 * and the number of options in the menu
 *
 * @param {HTMLElement} menuTrigger the trigger (ex. button) which invoked this menu.
 * Used in order to calculate the resulting size of the menu given the position of the trigger.
 * @param {HTMLElement} menu the DOM element containing the bootslide menu
 * @returns
 */
function getTiledBootslideMenuWidth (menuTrigger, menu) {

	let buttonBounds = menuTrigger[0].getBoundingClientRect()
	let buttonCenter = buttonBounds.left + (buttonBounds.width / 2)
	let distFromEdge = constants.TOOLTIP_ARROW_SPACING_FROM_EDGE + constants.TOOLTIP_ARROW_WIDTH/2

	let leftEdgeOfTooltip = buttonCenter - distFromEdge
	let bodyWidth = document.body.clientWidth
	let availableSpace = bodyWidth - leftEdgeOfTooltip - constants.STANDARD_MARGIN*2

	// See .bootslide-tiles styles in bootslide.scss
	let margin = constants.BOOTSLIDE_TILE_MARGIN
	let tileSpaceRequired = constants.BOOTSLIDE_TILE_WIDTH + margin
	let horizontalMargin = margin*2 // extra left/right spacing for the container

	// When given how many targets there are, return the width needed to
	// comfortably display those targets
	let widthFromTargets = numTargets => {
		let tilesPerRow
		if (tileSpaceRequired * 5 < availableSpace) {
			// If we can fit 5 using the default tooltip positioning, do it
			tilesPerRow = 5
		} else if (tileSpaceRequired * 4 < availableSpace) {
			// If we can fit 4 using the default tooltip positioning, do it
			tilesPerRow = 4
		} else {
			// Otherwise, just use 3 tiles per row. If that doesn't fit with
			// default tooltip positioning, just let the tooltip reposition
			// itself to fit in the window
			tilesPerRow = 3
		}

		if (tilesPerRow > numTargets) {
			tilesPerRow = numTargets
		}

		return tilesPerRow * tileSpaceRequired + horizontalMargin
	}

	// If there are categories in this tiled menu, the width should be based on
	// the section with the most tiles
	if (menu.find('.bootslide-category-label').length > 0) {
		let largest
		for (let nl of menu.find('.nav-list')) {
			let items = nl.children.length
			if (_.isNil(largest) || largest < items) {
				largest = items
			}
		}
		return widthFromTargets(largest)
	} else {
		return widthFromTargets(menu.find('.nav-list li').length)
	}
}

export default getTiledBootslideMenuWidth
getTiledBootslideMenuWidth.__filename__ = 'components/bootslide/get-tiled-bootslide-menu-width.js'
